'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconArrowUpLeftAndArrowDownRight, iconArrowUpLeftAndArrowDownRightTag } from '@ni/nimble-components/dist/esm/icons/arrow-up-left-and-arrow-down-right';
import { wrap } from '../../utilities/react-wrapper';

export type { IconArrowUpLeftAndArrowDownRight };
export { iconArrowUpLeftAndArrowDownRightTag };
export const NimbleIconArrowUpLeftAndArrowDownRight = wrap(IconArrowUpLeftAndArrowDownRight);